import React from "react";
import { GOV_WARNING } from "../data/content";
import { Instagram } from "lucide-react";
import PogLogo from "./PogLogo";

const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative bg-[#0C0906] text-[#EFE7D6] pt-24 md:pt-32 pb-12 border-t border-[#EFE7D6]/10 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-8 md:px-16">
        {/* Big centered logo */}
        <div className="text-center mb-20 md:mb-28">
          <div className="flex items-center justify-center gap-6 mb-8">
            <span className="w-16 md:w-24 hairline-strong h-px inline-block" />
            <span className="counter">10 — Fin</span>
            <span className="w-16 md:w-24 hairline-strong h-px inline-block" />
          </div>
          <PogLogo size={180} className="md:!h-[260px] mx-auto" />
          <div className="font-body text-xl md:text-2xl text-[#DCCFB4]/70 mt-8 tracking-wide">
            Spirits — Made in Hawai‘i
          </div>
        </div>

        <div className="grid md:grid-cols-12 gap-12 md:gap-16 pb-16 border-t border-[#EFE7D6]/12 pt-16">
          <div className="md:col-span-5">
            <div className="overline mb-6">The Brand</div>
            <p className="font-body text-xl text-[#EFE7D6]/90 leading-[1.5] max-w-md">
              POG juice was invented at Meadow Gold in 1971. POG Spirits is an
              independent spirits brand created in partnership with Meadow
              Gold, bringing that iconic flavor into a bottle in 2026.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-6">Explore</div>
            <ul className="space-y-3 text-sm">
              {["story", "products", "cocktails", "press", "faq", "inquire"].map((id) => (
                <li key={id}>
                  <button
                    onClick={() =>
                      document
                        .getElementById(id)
                        ?.scrollIntoView({ behavior: "smooth" })
                    }
                    className="text-[#EFE7D6]/70 hover:text-[#E85A15] capitalize transition-colors font-body tracking-wide text-[13px] link-underline"
                    data-testid={`footer-link-${id}`}
                  >
                    {id.replace("-", " ")}
                  </button>
                </li>
              ))}
              <li>
                <a
                  href="/journal"
                  className="text-[#EFE7D6]/70 hover:text-[#E85A15] capitalize transition-colors font-body tracking-wide text-[13px] link-underline"
                  data-testid="footer-link-journal"
                >
                  journal
                </a>
              </li>
              <li>
                <a
                  href="/press-kit"
                  className="text-[#EFE7D6]/70 hover:text-[#E85A15] capitalize transition-colors font-body tracking-wide text-[13px] link-underline"
                  data-testid="footer-link-press-kit"
                >
                  press kit
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline mb-6">Follow</div>
            <a
              href="https://www.instagram.com/pogspirits"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="social-instagram"
              className="inline-flex items-center gap-3 font-body text-sm text-[#EFE7D6]/70 hover:text-[#E85A15] transition-colors tracking-wide"
            >
              <Instagram size={16} strokeWidth={1.25} />
              <span className="link-underline">@pogspirits</span>
            </a>
            <div className="mt-10">
              <button
                onClick={() =>
                  document
                    .getElementById("inquire")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
                className="btn-ghost text-[10px]"
                data-testid="footer-inquire"
              >
                Inquire
              </button>
            </div>
          </div>
        </div>

        <div className="pt-12 grid md:grid-cols-12 gap-8 items-start border-t border-[#EFE7D6]/10">
          <div className="md:col-span-8">
            <div className="overline mb-4 text-[#EFE7D6]/40">
              Government Warning
            </div>
            <p className="font-body text-[10px] uppercase tracking-[0.15em] text-[#DCCFB4]/45 leading-[1.7]">
              {GOV_WARNING}
            </p>
          </div>
          <div className="md:col-span-4 md:text-right text-[10px] text-[#DCCFB4]/40 tracking-[0.15em] uppercase font-body leading-[1.7]">
            © {new Date().getFullYear()} POG Spirits
            <br />
            Please drink responsibly · 21+ only
            <br />
            POG® is a trademark of Meadow Gold Dairies of Hawai‘i
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
